export default __webpack_public_path__ + "static/media/ToolsFinder.b3473026.gif";